class OpenableItem extends HTMLElement {
	connectedCallback() {
		console.log('Openable item connected');
		this.overlay = document.querySelector('.modal__overlay');
		// TODO: maybe change toggle to show only
		// this.addEventListener('click', this.show.bind(this));
		this.addEventListener('click', this.toggle.bind(this));
		// on enter key
		this.addEventListener('keyup', this.onkeyup.bind(this));
		this.overlay.addEventListener('click', this.hide.bind(this));
		this.timeoutID = null;
	}
	get open() {
		return this.hasAttribute('open');
	}
	onkeyup(event) {
		if (event.code.toUpperCase() === 'ESCAPE') {
			this.hide(event);
		} else if (event.code.toUpperCase() === 'ENTER') {
			this.toggle(event);
		}
	}
	show(event) {
		event.stopPropagation();
		this.setAttribute('open', '');
		this.overlay.setAttribute('open', '');
		const rect = this.getBoundingClientRect();
		if (rect.top < 0 || rect.bottom > window.innerHeight) {
			this.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
			setTimeout(() => {
				document.body.classList.add('overflow-hidden');
			}, 500);
		} else {
			document.body.classList.add('overflow-hidden');
		}
		trapFocus(this, this.querySelector('[role="dialog"]'));
		// used for animation as z-index is not transitionable in css
		if (this.timeoutID) {
			clearTimeout(this.timeoutID);
		}
		this.style.zIndex = '5';
	}

	hide(event) {
		// prevent bubbling
		event.stopPropagation();
		this.removeAttribute('open');
		this.overlay.removeAttribute('open');
		document.body.classList.remove('overflow-hidden');
		removeTrapFocus(this.querySelector('[role="dialog"]'));
		this.blur();
		this.timeoutID = setTimeout(() => {
			this.style.zIndex = 'unset';
		}, 100);
	}
	toggle(event) {
		if (this.open) {
			this.hide(event);
		} else {
			this.show(event);
		}
	}
}
customElements.define('openable-item', OpenableItem);
